import React from 'react';
import { nbsp, percent, thousandSeparated } from '@gjensidige/gpf-js-utils/es6/text/formatting';
export const text = {
    COMMON: {
        YES: {
            no: 'Ja',
            en: 'Yes',
        },
        NO: {
            no: 'Nei',
            en: 'No',
        },
        NEXT: {
            no: 'Neste',
            en: '',
        },
        BACK: {
            no: 'Tilbake',
            en: '',
        },
        CANCEL: {
            no: 'Avbryt',
            en: '',
        },
        YEAR_POSTFIX: {
            no: 'år',
            en: 'years',
        },
        ALERT: {
            TITLE: {
                no: 'En feil har oppstått',
                en: '',
            },
            TEXT: {
                no: 'Vennligst ta kontakt med kundesenteret på 915 03100.',
                en: '',
            },
        },
        MIXED: {
            REQUIRED: {
                no: 'Verdien er påkrevd.',
                en: '',
            },
            NOT_TYPE: {
                no: 'Verdien er ikke gyldig.',
                en: '',
            },
        },
        NUMBER: {
            INTEGER: {
                no: 'Må oppgis i hele kroner.',
                en: '',
            },
            MIN: {
                no: 'Må være større enn eller lik ${min}.',
                en: '',
            },
            MAX: {
                no: 'Må være mindre enn eller lik ${max}.',
                en: '',
            },
        },
        COPY: {
            no: 'Kopier',
            en: 'Copy',
        },
        COPIED: {
            no: 'Kopiert',
            en: 'Copied',
        },
        PAGE_TITLE: {
            no: 'Start spareavtale',
            en: '',
        },
        PAGE_SUBTITLE: {
            no: 'Sparing i fond gir historisk sett langt bedre avkastning enn banksparing. Spar til det du vil og ta ut pengene når du vil.',
            en: '',
        },
        UNKNOWN_EXCEPTION_MESSAGE: {
            no: 'En uventet feil har oppstått. Prøv igjen.',
            en: '',
        },
    },
    PROFIL: {
        TRYGG: {
            no: 'Trygg',
            en: '',
        },
        BALANSERT: {
            no: 'Balansert',
            en: '',
        },
        OFFENSIV: {
            no: 'Offensiv',
            en: '',
        },
        ALDERSTILPASSET: {
            no: 'Alderstilpasset',
            en: '',
        },
    },
    PROFIL_PILL: {
        TRYGG: {
            no: 'Lavere forventet avkastning',
            en: '',
        },
        BALANSERT: {
            no: 'Lik fordeling aksje- og rentefond',
            en: '',
        },
        OFFENSIV: {
            no: 'Høyere forventet avkastning',
            en: '',
        },
        ALDERSTILPASSET: {
            no: 'Aksjeandel tilpasset alder',
            en: '',
        },
    },
    PROFIL_UTVIDET: {
        ALDERSTILPASSET: {
            no: (React.createElement("ul", null,
                React.createElement("li", null,
                    React.createElement("p", null, "Passer for deg som ikke \u00F8nsker \u00E5 velge aksje- og renteandel selv.")),
                React.createElement("li", null,
                    React.createElement("p", null, "Alderen bestemmer fordelingen mellom aksje- og rentefond.")),
                React.createElement("li", null,
                    React.createElement("p", null, "Passer godt for langsiktig sparing, gjerne til pensjon.")))),
            en: React.createElement(React.Fragment, null),
        },
        OFFENSIV: {
            no: (React.createElement("ul", null,
                React.createElement("li", null,
                    React.createElement("p", null, "Passer for deg som \u00F8nsker en offensiv sparing med h\u00F8y aksjeandel.")),
                React.createElement("li", null,
                    React.createElement("p", null, "H\u00F8y aksjeandel gj\u00F8r at verdien kan svinge mye i l\u00F8pet av sparetiden, men gir ogs\u00E5 mulighet for h\u00F8yere avkastning over tid.")),
                React.createElement("li", null,
                    React.createElement("p", null, "Passer for sparing i 5 \u00E5r eller mer.")))),
            en: React.createElement(React.Fragment, null),
        },
        TRYGG: {
            no: (React.createElement("ul", null,
                React.createElement("li", null,
                    React.createElement("p", null, "Passer for deg som er opptatt av trygghet og stabil avkastning.")),
                React.createElement("li", null,
                    React.createElement("p", null, "En lav aksjeandel gir mindre verdisvingninger, men reduserer ogs\u00E5 forventet avkastning.")),
                React.createElement("li", null,
                    React.createElement("p", null, "Passer for sparing i 1-3 \u00E5r.")))),
            en: React.createElement(React.Fragment, null),
        },
        BALANSERT: {
            no: (React.createElement("ul", null,
                React.createElement("li", null,
                    React.createElement("p", null, "Profilen har lik fordeling mellom aksje- og rentefond. Passer for deg som t\u00E5ler noe verdisvingning underveis og aktepterer lavere forventet avkastning enn i Offensiv profil.")),
                React.createElement("li", null,
                    React.createElement("p", null, "Passer for sparing i 3-5 \u00E5r.")))),
            en: React.createElement(React.Fragment, null),
        },
    },
    NAV_BUTTONS: {
        NEXT: {
            no: 'Neste',
            en: '',
        },
        BACK: {
            no: 'Tilbake',
            en: '',
        },
        SAVE: {
            no: 'Lagre',
            en: '',
        },
        SUBMIT: {
            no: 'Se og signer avtalen',
            en: '',
        },
        FINISH: {
            no: 'Fullfør',
            en: '',
        },
        CANCEL: {
            no: 'Avbryt',
            en: '',
        },
    },
    PROFIL_INFO_MODAL: {
        ARIA_LABEL: {
            no: 'Profil informasjon',
            en: '',
        },
        ARIA_LABEL_CLOSE: {
            no: 'Lukk profil informasjon',
            en: '',
        },
        BUTTON: {
            no: 'Les mer om profilen',
            en: '',
        },
        TITLE: (profil) => ({
            no: `Om ${profil} profil`,
            en: '',
        }),
        FOND_TABLE: {
            FONDSNAVN: {
                no: 'Fondsnavn',
                en: '',
            },
            AVKASTNING_HITTIL_I_ÅR: {
                no: 'Avkastning hittil i år',
                en: '',
            },
            AVKASTNING_3_ÅR: {
                no: 'Årlig avkastning siste 3 år',
                en: '',
            },
            AVKASTNING_5_ÅR: {
                no: 'Årlig avkastning siste 5 år',
                en: '',
            },
        },
        NEDTRAPPING: {
            TITLE: {
                no: 'Nedtrapping av aksjefondsandel',
                en: '',
            },
            DESCRIPTION: {
                no: 'Aksjeandelen er 50% til og med fylte 61 år. Deretter trapper vi den gradvis ned og reduserer risikoen ved å inkludere rentefond. Dette sikrer at sparepengene dine svinger mindre i verdi før- og under utbetaling.',
                en: '',
            },
        },
        RISIKO: {
            TITLE: {
                no: 'Risikovurdering',
                en: '',
            },
        },
    },
    ANBEFALING_MODAL: {
        ARIA_LABEL: {
            no: 'Bakgrunn for anbefalingen',
            en: '',
        },
        ARIA_LABEL_CLOSE: {
            no: 'Lukk bakgrunn for anbefaling',
            en: '',
        },
        BAKGRUNN_FOR_ANBEFALING: {
            no: 'Bakgrunn for anbefalingen',
            en: '',
        },
        VALGT_PROFIL: (anbefaltProfil) => ({
            no: `${anbefaltProfil} profil`,
            en: '',
        }),
        BEGRUNNELSE_FORKLARING: (anbefaltProfil) => ({
            no: `Vi anbefaler ${anbefaltProfil} profil basert på svarene dine:`,
            en: '',
        }),
    },
    AUTOMATISERTE_PROSESSER_MODAL: {
        ARIA_LABEL: {
            no: 'Automatiserte individuelle avgjørelser',
            en: '',
        },
        ARIA_LABEL_CLOSE: {
            no: 'Lukk',
            en: '',
        },
        TITLE: {
            no: 'Automatiserte individuelle avgjørelser',
            en: '',
        },
        SUBTITLE: {
            no: 'I Gjensidige bruker vi automatiserte individuelle avgjørelser. De er viktige for en effektiv drift. I slike avgjørelser kan profilering inngå. Dersom resultatet av automatiske individuelle avgjørelser påvirker deg i betydelig grad, kan du kreve manuell vurdering av avgjørelsen. I de tilfeller der denne retten oppstår vil du få informasjon om dette.',
            en: '',
        },
        BUY_ONLINE: {
            TITLE: {
                no: 'Kjøp av pensjonsforsikring på nett',
                en: '',
            },
            CONTENT: {
                no: 'Kjøp av pensjonsforsikring på nett er en automatisert prosess. På bakgrunn av de automatiserte avgjørelsene i prosessen vil du enten få tilbud om forsikring, bli stoppet i kjøpsprosessen eller du kan be om manuell behandling. Avgjørelsene er basert på reglene for kjøp av forsikring. Informasjon vi ber om i prosessen er nødvendig for å kunne tilby forsikring.',
                en: '',
            },
        },
    },
    PERSONVERN_INFO_MODAL: {
        ARIA_LABEL: {
            no: 'Behandling av personopplysninger',
            en: '',
        },
        ARIA_LABEL_CLOSE: {
            no: 'Lukk',
            en: '',
        },
        BUTTON: {
            no: 'Les om hvordan vi behandler personopplysningene dine',
            en: '',
        },
        MODAL: {
            TITLE: {
                no: 'Behandling av personopplysninger',
                en: '',
            },
            SUBTITLE: {
                no: 'Vi tar personopplysningene dine på alvor og vil at du skal føle deg trygg på at vi beskytter dem. Her kan du lese om hvorfor vi samler inn og bruker personopplysninger, og hvilke rettigheter du har.',
                en: '',
            },
            WHAT: {
                TITLE: {
                    no: 'Hva er personopplysninger?',
                    en: '',
                },
                CONTENT: {
                    no: 'Personopplysninger er opplysninger som kan knyttes direkte til deg som person, for eksempel fødselsnummer, kontaktopplysninger og opplysninger om hvilke produkter du har kjøpt hos oss. Slike opplysninger er nødvendige for at vi skal kunne gi deg god kundebehandling.',
                    en: '',
                },
            },
            RIGHTS: {
                TITLE: {
                    no: 'Hvilke rettigheter har du?',
                    en: '',
                },
                INNSYN: {
                    TITLE: {
                        no: 'Innsyn',
                        en: '',
                    },
                    CONTENT: {
                        no: 'Du har rett til å be om innsyn i hvilke av personopplysningene dine vi behandler og du har rett til å få en kopi av disse personopplysningene.',
                        en: '',
                    },
                },
                KORRIGERING: {
                    TITLE: {
                        no: 'Korrigering',
                        en: '',
                    },
                    CONTENT: {
                        no: 'Dersom du mener at de personopplysninger vi har om deg ikke er riktige eller er ufullstendige, har du rett til å be om at personopplysningen rettes eller oppdateres.',
                        en: '',
                    },
                },
                SLETTING: {
                    TITLE: {
                        no: 'Sletting',
                        en: '',
                    },
                    CONTENT: {
                        no: 'Du kan be om at vi sletter personopplysningene dine dersom:',
                        en: '',
                    },
                    LIST_ITEMS: {
                        no: (React.createElement(React.Fragment, null,
                            React.createElement("li", null, "du mener at personopplysningene ikke lenger er n\u00F8dvendige for form\u00E5let de var innhentet til"),
                            React.createElement("li", null, "du \u00F8nsker \u00E5 trekke tilbake et samtykke du har gitt oss og som har latt oss bruke personopplysningene"),
                            React.createElement("li", null, "eller at behandlingen av personopplysningene ikke utf\u00F8res i tr\u00E5d med gjeldende lov."))),
                        en: '',
                    },
                },
            },
            FOOTER: {
                no: 'Vi er pliktige til å oppbevare personopplysninger om deg i en gitt periode dersom du har hatt en forsikring hos oss med foreldelsesfrist. I slike tilfeller er det nødvendig å oppbevare opplysninger om deg på grunn av muligheten for fremtidige erstatningskrav som kan tilbakeføres til avtaleforholdet. Retten til sletting av dine personopplysninger gjelder ikke i slike tilfeller.',
                en: '',
            },
        },
    },
    LOGIN: {
        TITLE: {
            no: 'Om deg',
            en: '',
        },
        DESCRIPTION: {
            no: 'For at du skal få et personlig tilbud med de rabattene du har krav på, må vi først vite litt om deg. Hvis du har opprettet spareavtale tidligere, kan vi finne frem informasjonen du har gitt.',
        },
        INVALID_AGE: {
            no: 'For å spare i Fondskonto må du være over 18 år. Ring oss på 915 03100, chat med oss eller send e-post til ps@gjensidige.no, så hjelper vi deg.',
            en: '',
        },
        BUTTONS: {
            LOGG_INN: {
                no: 'Logg inn med BankID',
                en: '',
            },
            FORTSETT_UTEN: {
                no: 'Fortsett uten',
                en: '',
            },
        },
    },
    FORM: {
        KONTO_FORM: {
            SSN: {
                VALIDATION: {
                    REQUIRED: {
                        no: 'Legg til et gyldig fødselsnummer.',
                        en: '',
                    },
                    INVALID: {
                        no: 'Fødselsnummeret er ikke gyldig.',
                        en: '',
                    },
                },
            },
            BARNETS_NAVN: {
                no: 'Barnets navn (brukes også som kontonavn)',
                en: '',
            },
            BARNETS_FNR: {
                LABEL: {
                    no: 'Barnets fødselsnummer (11 siffer)',
                    en: '',
                },
                HELP_TEXT: {
                    no: 'Informasjonen du oppgir blir kryptert, slik at det er helt trygt å legge inn fødselsnummer (fødselsdato og personnummer).',
                    en: '',
                },
            },
            SPAREFORMÅL: {
                TITLE: {
                    no: 'Hva vil du spare til?',
                    en: '',
                },
                OPTIONS: {
                    PENSJON: {
                        LABEL: {
                            no: 'Til jeg pensjonerer meg',
                            en: '',
                        },
                        DESCRIPTION: {
                            no: 'Jeg vil spare så jeg har større frihet når jeg blir pensjonist.',
                            en: '',
                        },
                    },
                    BARN_BARNEBARN: {
                        LABEL: {
                            no: 'Til barn eller barnebarn',
                            en: '',
                        },
                        DESCRIPTION: {
                            no: 'Jeg vil spare til barn eller barnebarn, sånn at de kan få pengene når de blir eldre.',
                            en: '',
                        },
                    },
                    SPESIFIKT_MÅL: {
                        LABEL: {
                            no: 'Til et spesifikt mål',
                            en: '',
                        },
                        DESCRIPTION: {
                            no: 'Jeg ønsker å spare til hus, ferie, hytte eller lignende.',
                            en: '',
                        },
                    },
                    IKKE_SPESIFIKT_MÅL: {
                        LABEL: {
                            no: 'Har ikke et spesifikt mål',
                            en: '',
                        },
                        DESCRIPTION: {
                            no: 'Jeg ønsker å spare i fond fordi jeg kan få god avkastning på pengene mine.',
                            en: '',
                        },
                    },
                },
                VALIDATION: {
                    REQUIRED: {
                        no: 'Velg et spareformål.',
                        en: '',
                    },
                },
                INFO_ALERT: {
                    no: 'Ønsker du å opprette flere fondskontoer, kan du gjøre det etter at du har opprettet og signert avtalen. \n' +
                        'Da gjenbruker vi noe av den informasjonen du oppgir. ',
                    en: '',
                },
            },
            OPPRETT_FLER_VARSEL: {
                no: 'Ønsker du flere fondskontoer, kan du opprette dem etter at du har signert denne avtalen.',
                en: '',
            },
            KONTONAVN: {
                DEFAULT_VALUE: {
                    no: 'Fondskonto',
                    en: '',
                },
                TITLE: {
                    no: 'Gi spareavtalen din et navn',
                    en: '',
                },
                LABEL_TEXT: {
                    no: 'Navn på spareavtale (valgfritt)',
                    en: '',
                },
                VALIDATION: {
                    INVALID: {
                        no: 'Ugyldig navn på spareavtale.',
                        en: '',
                    },
                },
            },
        },
        ABOUT_FORM: {
            TITLE: {
                no: 'Om deg',
                en: '',
            },
            DESCRIPTION: {
                no: 'For å opprette avtalen trenger vi noen opplysninger om deg.',
                en: '',
            },
            SSN: {
                LABEL_TEXT: {
                    no: 'Fødselsnummer (11 siffer)',
                    en: '',
                },
                HELP_TEXT: {
                    no: 'Informasjonen du oppgir blir kryptert, slik at det er helt trygt å legge inn fødselsnummeret ditt (fødselsdato og personnummer).',
                    en: '',
                },
                VALIDATION: {
                    REQUIRED: {
                        no: 'Legg inn fødselsnummeret ditt.',
                        en: '',
                    },
                    INVALID: {
                        no: 'Fødselsnummeret er ikke gyldig.',
                        en: '',
                    },
                    INVALID_AGE: {
                        no: 'Du er for ung til å starte spareavtale på nett. Skal du spare til barnet ditt – ring oss på 915 03100, så hjelper vi deg.',
                        en: '',
                    },
                },
            },
            FIRSTNAME: {
                LABEL_TEXT: {
                    no: 'For- og mellomnavn',
                    en: '',
                },
                VALIDATION: {
                    REQUIRED: {
                        no: 'Legg inn fornavnet ditt.',
                        en: '',
                    },
                },
            },
            SURNAME: {
                LABEL_TEXT: {
                    no: 'Etternavn',
                    en: '',
                },
                VALIDATION: {
                    REQUIRED: {
                        no: 'Legg inn etternavnet ditt.',
                        en: '',
                    },
                },
            },
            EMAIL: {
                LABEL_TEXT: {
                    no: 'E-post',
                    en: '',
                },
                VALIDATION: {
                    REQUIRED: {
                        no: 'Legg inn e-postadressen din.',
                        en: '',
                    },
                    INVALID: {
                        no: 'Ikke en gyldig e-postadresse.',
                        en: '',
                    },
                },
            },
            VALIDATION: {
                VALIDATION_FAILED: {
                    no: 'Det oppstod en systemfeil under validering. Prøv igjen.',
                    en: '',
                },
                INVALID_CUSTOMER: {
                    no: 'Fødselsnummer og navn stemmer ikke overens.',
                    en: '',
                },
                AGE_WARNING: (age) => ({
                    no: (React.createElement(React.Fragment, null,
                        "Siden du er ",
                        age,
                        " \u00E5r anbefaler vi deg \u00E5 ta en prat med oss f\u00F8r du starter spareavtale. Ring oss p\u00E5 915 03100, eller",
                        ' ',
                        React.createElement("a", { href: "https://www.gjensidige.no/privat/pensjon/pensjonsradgivning", rel: "noopener noreferrer", target: "_blank" }, "be om \u00E5 bli kontaktet."))),
                    en: '',
                }),
            },
        },
        AMOUNT_FORM: {
            TITLE: {
                no: 'Velg sparebeløp',
                en: '',
            },
            DESCRIPTION: {
                no: 'Minimumsbeløpet er 300 kroner.',
            },
            LUMP_SUM: {
                LABEL_TEXT: {
                    no: 'Enkeltbeløp',
                    en: '',
                },
                HELP_TEXT: {
                    no: 'Enkeltbeløp - spar litt ekstra når det passer deg',
                    en: '',
                },
            },
            ANNUITY: {
                LABEL_TEXT: {
                    no: 'Månedlig sparing',
                    en: '',
                },
                HELP_TEXT: {
                    no: 'Månedlig sparing - spar jevnt og trutt',
                    en: '',
                },
            },
            VALIDATION: {
                REQUIRED: (minAmount) => ({
                    no: `Minimumsbeløpet er ${thousandSeparated(minAmount)} kroner i enkeltbeløp eller månedlig sparebeløp.`,
                    en: '',
                }),
                MIN: (minAmount) => ({
                    no: `Minimumsbeløpet er ${thousandSeparated(minAmount)} kroner.`,
                    en: '',
                }),
            },
            CREATE_SAVINGS_AGREEMENT_BUTTON: {
                no: 'Neste',
                en: '',
            },
        },
        RAADGIVNING_FATCA: {
            PREV_ANSWERS_TITLE: {
                no: 'Tidligere oppgitte opplysninger',
                en: '',
            },
            PREV_ANSWERS_DESCRIPTION: {
                no: 'Du har tidligere opprettet spareavtale hos oss og oppgitt svarene nedenfor. Se over at disse opplysningene om deg stemmer. ',
                en: '',
            },
            CHANGE_ANSWER: (section) => ({
                no: `Endre svar ${section.toLowerCase()}`,
                en: '',
            }),
            OPEN_MODAL: {
                no: 'Les mer om automatiserte prosesser og retten til manuell behandling.',
                en: '',
            },
        },
        RAADGIVNING_EGNETHET: {
            TITLE: {
                no: 'Noen spørsmål om deg og forventningene dine',
                en: '',
            },
            DESCRIPTION: {
                no: 'For å kunne gi deg en anbefalt fordeling mellom aksje- og rentefond, må vi stille deg noen spørsmål. Svarene dine er avgjørende for anbefalingen vi gir deg.',
                en: '',
            },
            TIDSBRUK: {
                no: 'Det tar bare noen få minutter.',
                en: '',
            },
            DEFAULT_ANSWER_MISSING: {
                no: 'Mangler standard svaralternativ for spørsmål om tidshorisont. Undersøk respons fra rådgivning-api.',
                en: '',
            },
        },
        PROFILE_FORM: {
            TITLE: {
                no: 'Velg profil',
                en: '',
            },
            NEXT_TEXT: {
                no: 'Velg profil',
                en: '',
            },
            DESCRIPTION: {
                no: 'Vi tilbyr profiler med ulik fordeling mellom aksje- og rentefond og forventet avkastning.',
                en: '',
            },
            FRITT_FONDSVALG_INFO: {
                no: 'Du kan velge fritt fra hele fondsoversikten når avtalen er opprettet.',
                en: '',
            },
            LES_MER_OM_PROFILEN: {
                no: 'Les mer om profilen',
                en: '',
            },
            ANBEFALT_PROFIL_PILL: {
                no: 'Anbefalt profil',
                en: '',
            },
            BEKREFT_MODAL: {
                ARIA_LABEL: {
                    no: 'Bekreft ny profil',
                    en: '',
                },
                ARIA_LABEL_CLOSE: {
                    no: 'Behold anbefalt profil',
                    en: '',
                },
                TITLE: {
                    no: 'Du er i ferd med å velge en profil med en annen risiko enn den anbefalte, er du sikker på at du vil velge denne?',
                    en: '',
                },
                BEKREFT: {
                    no: 'Bekreft ny profil',
                    en: '',
                },
                AVBRYT: {
                    no: 'Behold anbefalt profil',
                    en: '',
                },
            },
            INVESTMENT_PROFILE: {
                ALLOCATION: (aksjeandel, renteandel) => ({
                    no: `${percent(aksjeandel)} aksjefond og ${percent(renteandel)} rentefond`,
                    en: '',
                }),
                ALLOCATION_FORMATTED: {
                    AKSJEFOND: (andel) => ({
                        no: (React.createElement(React.Fragment, null,
                            React.createElement("strong", null, percent(andel)),
                            " aksjefond")),
                        en: '',
                    }),
                    RENTEFOND: (andel) => ({
                        no: (React.createElement(React.Fragment, null,
                            React.createElement("strong", null, percent(andel)),
                            " rentefond")),
                        en: '',
                    }),
                },
                ALDERSTILPASSET: {
                    TITLE: {
                        no: 'Alderstilpasset',
                        en: '',
                    },
                    DESCRIPTION: {
                        no: 'Passer best for langsiktig sparing',
                        en: '',
                    },
                    ALLOCATION: {
                        no: 'Alderen din avgjør fordelingen mellom aksje- og rentefond',
                        en: '',
                    },
                    DESCRIPTION_WITH_ALLOCATION: () => ({
                        no: `${text.FORM.PROFILE_FORM.INVESTMENT_PROFILE.ALDERSTILPASSET.ALLOCATION.no}\n${text.FORM.PROFILE_FORM.INVESTMENT_PROFILE.ALDERSTILPASSET.DESCRIPTION.no}`,
                        en: '',
                    }),
                    DESCRIPTION_AND_ALLOCATION: () => ({
                        no: `${text.FORM.PROFILE_FORM.INVESTMENT_PROFILE.ALDERSTILPASSET.ALLOCATION.no}. ${text.FORM.PROFILE_FORM.INVESTMENT_PROFILE.ALDERSTILPASSET.DESCRIPTION.no}.`,
                        en: '',
                    }),
                },
                TRYGG: {
                    TITLE: {
                        no: 'Trygg',
                        en: '',
                    },
                    DESCRIPTION: {
                        no: 'Passer for sparing i 1-3 år',
                        en: '',
                    },
                    DESCRIPTION_WITH_ALLOCATION: (fordeling) => ({
                        no: `${text.FORM.PROFILE_FORM.INVESTMENT_PROFILE.ALLOCATION(fordeling.aksjeandel, fordeling.renteandel).no}\n${text.FORM.PROFILE_FORM.INVESTMENT_PROFILE.TRYGG.DESCRIPTION.no}`,
                        en: '',
                    }),
                    DESCRIPTION_AND_ALLOCATION: (fordeling) => ({
                        no: `${text.FORM.PROFILE_FORM.INVESTMENT_PROFILE.ALLOCATION(fordeling.aksjeandel, fordeling.renteandel).no}. ${text.FORM.PROFILE_FORM.INVESTMENT_PROFILE.TRYGG.DESCRIPTION.no}.`,
                        en: '',
                    }),
                },
                BALANSERT: {
                    TITLE: {
                        no: 'Balansert',
                        en: '',
                    },
                    DESCRIPTION: {
                        no: 'Passer for sparing i 3-5 år',
                        en: '',
                    },
                    DESCRIPTION_WITH_ALLOCATION: (fordeling) => ({
                        no: `${text.FORM.PROFILE_FORM.INVESTMENT_PROFILE.ALLOCATION(fordeling.aksjeandel, fordeling.renteandel).no}\n${text.FORM.PROFILE_FORM.INVESTMENT_PROFILE.BALANSERT.DESCRIPTION.no}`,
                        en: '',
                    }),
                    DESCRIPTION_AND_ALLOCATION: (fordeling) => ({
                        no: `${text.FORM.PROFILE_FORM.INVESTMENT_PROFILE.ALLOCATION(fordeling.aksjeandel, fordeling.renteandel).no}. ${text.FORM.PROFILE_FORM.INVESTMENT_PROFILE.BALANSERT.DESCRIPTION.no}.`,
                        en: '',
                    }),
                },
                OFFENSIV: {
                    TITLE: {
                        no: 'Offensiv',
                        en: '',
                    },
                    DESCRIPTION: {
                        no: 'Passer for sparing i 5 år eller mer',
                        en: '',
                    },
                    DESCRIPTION_WITH_ALLOCATION: (fordeling) => ({
                        no: `${text.FORM.PROFILE_FORM.INVESTMENT_PROFILE.ALLOCATION(fordeling.aksjeandel, fordeling.renteandel).no}\n${text.FORM.PROFILE_FORM.INVESTMENT_PROFILE.OFFENSIV.DESCRIPTION.no}`,
                        en: '',
                    }),
                    DESCRIPTION_AND_ALLOCATION: (fordeling) => ({
                        no: `${text.FORM.PROFILE_FORM.INVESTMENT_PROFILE.ALLOCATION(fordeling.aksjeandel, fordeling.renteandel).no}. ${text.FORM.PROFILE_FORM.INVESTMENT_PROFILE.OFFENSIV.DESCRIPTION.no}.`,
                        en: '',
                    }),
                },
                VALIDATION: {
                    REQUIRED: {
                        no: 'Velg en ny profil eller gå tilbake.',
                        en: '',
                    },
                },
            },
        },
        RAADGIVNING_EGNETHET_RESULT: {
            // PILL:
            AKSJEANDEL: {
                no: `aksjefond`,
                en: '',
            },
            RENTEANDEL: {
                no: 'rentefond',
                en: '',
            },
            ANBEFALT_PROFIL: {
                no: 'Anbefalt profil',
                en: '',
            },
            RISIKO_NEEDLE: {
                no: 'Risiko 1-7',
                en: '',
            },
            AVKASTNING_HITTIL_I_ÅR: {
                no: 'Avkastning hittil i år',
                en: '',
            },
            AVKASTNING_SISTE_5_ÅR: {
                no: 'Avkastning siste 5 år',
                en: '',
            },
            HØY_AKSJEANDEL: {
                no: 'Høy aksjeandel gjør at verdien kan svinge mye i løpet av sparetiden, men gir også mulighet for høyere avkastning over tid.',
                en: '',
            },
            LES_MER_OM_PROFIL: {
                no: 'Les mer om profilen',
                en: '',
            },
            BAKGRUNN_FOR_ANBEFALING: {
                no: 'Bakgrunn for anbefalingen',
                en: '',
            },
            VELG_ANBEFALT_PROFIL: {
                no: 'Velg anbefalt profil',
                en: '',
            },
            SE_FLERE_PROFILER: {
                no: 'Se flere profiler',
                en: '',
            },
            NY_VURDERING: {
                no: 'Vi tilbyr ikke periodisk egnethetsvurdering. Om du ønsker en ny vurdering, kan du få hjelp av rådgiverne våre.',
                en: '',
            },
        },
        PAYOUT_FORM: {
            PAYOUT_TITLE: {
                no: 'Plan for utbetaling',
                en: '',
            },
            PAYOUT_DESCRIPTION: {
                no: 'Du kan når som helst endre utbetalingstidspunktet.',
                en: '',
            },
            START_AGE: {
                LABEL_TEXT: {
                    no: 'Når ønsker du å starte utbetaling? Skriv inn alder (f.eks. 67)',
                    en: '',
                },
            },
            PAYOUT_HEADER: {
                no: 'Ønsker du engangsutbetaling eller månedlige utbetalinger?',
                en: '',
            },
            PAYOUT: {
                LUMP_SUM: {
                    no: 'Engangsutbetaling',
                    en: '',
                },
                MONTHLY: {
                    no: 'Månedlige utbetalinger',
                    en: '',
                },
            },
            DISTRIBUTION: {
                LABEL_TEXT: {
                    no: 'Over hvor mange år ønsker du å fordele utbetalingene?',
                    en: '',
                },
                HELP_TEXT: {
                    no: 'Utbetalingene kan fordeles mellom 1 til 15 år.',
                    en: '',
                },
            },
        },
        PURPOSE_FORM: {
            PURPOSE_TITLE: {
                no: 'Formålet med investeringen',
                en: '',
            },
            TIME_HORIZON_HEADER: {
                no: 'Er sparehorisonten langsiktig eller kortsiktig?',
                en: '',
            },
            TIME_HORIZON: {
                SHORT: {
                    no: 'Kortsiktig\n(1-5 år)',
                    en: '',
                },
                LONG: {
                    no: 'Langsiktig\n(mer enn 5 år)',
                    en: '',
                },
            },
            GIFT_HEADER: {
                no: 'Er midlene som skal investeres arv, gave og/eller gevinst?',
                en: '',
            },
            LARGE_AMOUNT_HEADER: {
                no: 'Skal du investere mer enn 3 millioner NOK?',
                en: '',
            },
            OWNER_OR_RECEIVER: {
                HEADER: {
                    no: 'Er du eier eller mottaker av midlene som skal investeres/utbetales?',
                    en: '',
                },
                ERROR_TEXT: {
                    no: (React.createElement(React.Fragment, null,
                        "Siden du har opplyst at du ikke er eier av midlene som skal investeres, trenger vi mer informasjon.",
                        ' ',
                        React.createElement("a", { href: "https://www.gjensidige.no/privat/sparing/radgivning" }, "Kontakt oss, s\u00E5 hjelper vi deg videre"),
                        ".")),
                    en: '',
                },
            },
            POLITICALLY_EXPOSED: {
                HEADER: {
                    no: 'Er du, eller er du nær, en politisk eksponert person utenfor Norge?',
                    en: '',
                },
                HELP_TEXT: {
                    no: (React.createElement(React.Fragment, null,
                        "Med politisk eksponert person menes personer som i l\u00F8pet av det siste \u00E5ret har:",
                        React.createElement("ul", null,
                            React.createElement("li", null, "innehatt h\u00F8ytst\u00E5ende offentlig verv eller stilling i annen stat enn Norge, eller"),
                            React.createElement("li", null, "er familiemedlem til en slik person, eller"),
                            React.createElement("li", null, "er n\u00E6r medarbeider til slik person")))),
                    en: '',
                },
                ERROR_TEXT: {
                    no: 'Avtale kan ikke inngås på nett med en politisk eksponert person.',
                    en: '',
                },
            },
        },
        TAX_FORM: {
            TAX_TITLE: {
                no: 'Rapportering av skatteopplysninger',
                en: '',
            },
            TAX_DESCRIPTION: {
                no: 'Vi er pålagt å rapportere sparingen din til myndighetene i det landet du er skattemessig bosatt.',
                en: '',
            },
            NORWEGIAN_CITIZEN_HEADER: {
                no: 'Er du norsk statsborger?',
                en: '',
            },
            AMERICAN_CITIZEN: {
                HEADER: {
                    no: 'Er du amerikansk statsborger?',
                    en: '',
                },
                ERROR_TEXT: {
                    no: 'Avtale kan ikke inngås med amerikanske statsborgere eller personer som er skattepliktig til USA.',
                    en: '',
                },
            },
            CITIZENSHIP: {
                LABEL_TEXT: {
                    no: 'Er du statsborger i andre land?',
                    en: '',
                },
                ERROR_TEXT: {
                    no: 'Siden du har oppgitt at du ikke er norsk statsborger, må du velge et land her.',
                    en: '',
                },
                PLACEHOLDER: {
                    no: 'Nei',
                    en: '',
                },
            },
            AMERICAN_TAX_RELATION_HEADER: {
                no: 'Er du skattemessig bosatt i USA?',
                en: '',
            },
            TAX_RELATIONS: {
                HEADER: {
                    no: 'Er du skattemessig bosatt i andre land?',
                    en: '',
                },
                COUNTRY_LABEL_TEXT: {
                    no: 'Oppgi land med skattemessig tilknytning',
                    en: '',
                },
                TIN_LABEL_TEXT: {
                    no: 'Skattenummer (TIN)',
                    en: '',
                },
            },
            ADD_TAX_RELATION: {
                no: 'Legg til et land til',
                en: '',
            },
            REMOVE_TAX_RELATION: {
                no: 'Fjern land',
                en: '',
            },
        },
        SUMMARY: {
            TITLE: {
                no: 'Avtalen din',
                en: '',
            },
            KONTONAVN: {
                CHANGE: {
                    no: 'Endre navn',
                    en: '',
                },
                DEFAULT_KONTONAVN: {
                    no: 'Fondskonto',
                    en: '',
                },
            },
            CHANGE: {
                no: 'Endre',
                en: '',
            },
            SPAREFORMÅL: {
                TITLE: {
                    no: 'Spareformål',
                    en: '',
                },
                CHANGE_SPAREFORMÅL: {
                    no: 'Endre spareformål',
                    en: '',
                },
                OPTIONS: {
                    PENSJON: {
                        LABEL: {
                            no: 'Sparer til pensjon',
                            en: '',
                        },
                    },
                    BARN_BARNEBARN: {
                        LABEL: {
                            no: 'Sparer til barn eller barnebarn',
                            en: '',
                        },
                    },
                    SPESIFIKT_MÅL: {
                        LABEL: {
                            no: 'Sparer til et spesifikt mål',
                            en: '',
                        },
                    },
                    IKKE_SPESIFIKT_MÅL: {
                        LABEL: {
                            no: 'Sparer ikke til et spesifikt mål',
                            en: '',
                        },
                    },
                },
            },
            PAYOUT: {
                TITLE: {
                    no: 'Utbetaling',
                    en: '',
                },
                CONTENT: {
                    PAYOUT_AGE: (age) => ({
                        no: (React.createElement(React.Fragment, null,
                            "Du kan n\u00E5r som helst ta ut pengene, men utbetaling settes automatisk opp som m\u00E5nedlig utbetaling over 10 \u00E5r fra det \u00E5ret du fyller ",
                            age,
                            " \u00E5r.")),
                        en: '',
                    }),
                    STEP_DOWN: {
                        no: `I årene før utbetaling, reduserer vi aksjeandelen gradvis til ${nbsp('20 %')}. Det er for å unngå store verdisvingninger rett før utbetaling.`,
                        en: '',
                    },
                },
                SPAREFORMÅL_BARN: {
                    TITLE: {
                        no: 'Vet du når barnet skal ta ut pengene?',
                        en: '',
                    },
                    CONTENT: {
                        no: 'Da kan vi redusere aksjeandelen gradvis for å unngå store verdisvingninger rett før utbetaling. Hvis du ikke vet, så er det helt greit. Du kan ta ut pengene når som helst, og kontakte oss hvis du ønsker å redusere aksjeandelen på et senere tidspunkt.',
                        en: '',
                    },
                },
                VALIDATION_FAILED: {
                    no: 'Det oppstod en systemfeil under validering. Prøv igjen.',
                    en: '',
                },
            },
            FONDSVALG: {
                TITLE: {
                    no: 'Fondsvalg',
                    en: '',
                },
                CHANGE: {
                    no: 'Endre fondsvalg',
                    en: '',
                },
                DESCRIPTION: {
                    no: 'Endre fondsvalg',
                    en: '',
                },
            },
            SAVINGS_AMOUNT: {
                TITLE: {
                    no: 'Månedlig sparebeløp',
                    en: '',
                },
                TITLE_MONTHLY: {
                    no: 'Månedlig sparebeløp',
                    en: '',
                },
                TITLE_LUMPSUM: {
                    no: 'Engangsbeløp',
                    en: '',
                },
                POSTFIX: {
                    no: ' kr/mnd',
                    en: '',
                },
                POSTFIX_MONTHLY: {
                    no: ' kr/mnd',
                    en: '',
                },
                POSTFIX_LUMPSUM: {
                    no: ' kr',
                    en: '',
                },
                CHANGE_AMOUNT: {
                    no: 'Endre sparebeløp',
                    en: '',
                },
            },
            BENEFITS: {
                TITLE: {
                    no: 'Disse endringene kan du gjøre når avtalen er opprettet',
                    en: '',
                },
                CHECKED_LIST: {
                    CHANGE_AMOUNT: {
                        no: 'endre sparebeløp',
                        en: '',
                    },
                    WITHRAWAL: {
                        no: 'bestille uttak',
                        en: '',
                    },
                    FUNDSWITCH: {
                        no: 'endre fondsvalg',
                        en: '',
                    },
                    VALUE_CHANGE: {
                        no: 'følge verdiutviklingen',
                        en: '',
                    },
                },
            },
        },
    },
    LAYOUT: {
        START_SAVING: {
            TITLE: {
                no: 'Start sparing i fond',
                en: '',
            },
            SUBTITLE: {
                no: (React.createElement(React.Fragment, null,
                    "Denne digitale r\u00E5dgiveren skal autoriseres av Finansn\u00E6ringens autorisasjonsordninger innen 1.juli 2024. Autorisasjonen skal gi en trygghet for at l\u00F8sningen ikke bare oppfyller lovkrav, men ogs\u00E5 finansn\u00E6ringens bransjenorm God Skikk. Les mer her:",
                    ' ',
                    React.createElement("a", { href: "https://www.finaut.no/autorisasjonsordning-digitale-radgivningslosninger/robot/", rel: "noopener noreferrer", target: "_blank" }, "finaut.no/robot"),
                    ".")),
                en: '',
            },
        },
        SIGNED_AGREEMENT: {
            TITLE: {
                no: 'Du har opprettet spareavtale',
                en: '',
            },
        },
        SIGNED_AVTALEGIRO: {
            TITLE: {
                no: 'Sparingen er i gang',
                en: '',
            },
        },
    },
    DOCUMENT_SIGNED_PAGE: {
        TITLE: {
            no: 'Start sparing i fond',
            en: '',
        },
        CARD: {
            TITLE: {
                no: 'Start sparing',
                en: '',
            },
        },
        START_SAVING: {
            ANNUITY_AND_LUMP_SUM: {
                no: 'Du har avtalt månedlig sparing og engangsinnskudd.',
                en: '',
            },
            ANNUITY_WITHOUT_LUMP_SUM: {
                no: 'Du har avtalt månedlig sparing.',
                en: '',
            },
            LUMP_SUM_WITHOUT_ANNUITY: {
                no: 'Du har avtalt engangsinnskudd.',
                en: '',
            },
            NO_SAVING: {
                no: 'Du har ikke avtalt noen sparing.',
                en: '',
            },
            START_SAVING: {
                no: 'Start sparing i fond nå',
                en: '',
            },
        },
        ERROR: {
            HEADER: {
                no: 'Signering ble avbrutt',
                en: '',
            },
            VELKOMMEN_TILBAKE: {
                no: 'Du er velkommen tilbake når som helst.',
                en: '',
            },
            TRY_AGAIN: {
                no: 'Prøv å signere på nytt',
                en: '',
            },
            SIGNERT_MEN_IKKE_OPPRETTET: {
                no: 'Du vil snart få en e-post med informasjon om opprettelse av AvtaleGiro og innbetaling av engangsbeløp. ' +
                    'Så snart avtalen er registrert, vil du også finne informasjonen under avtaleoversikten.',
                en: '',
            },
            MISSING_REQUEST_ID: {
                no: 'Noe gikk galt.',
                en: '',
            },
        },
        FETCHING: {
            HEADER: {
                no: 'Vi sjekker nå om signeringen var vellykket',
                en: '',
            },
            PLEASE_WAIT: {
                no: 'Vennligst vent',
                en: '',
            },
        },
    },
    START_SAVING_PAGE: {
        TITLE: {
            no: 'Start sparing',
            en: '',
        },
        MONTHLY: {
            TITLE: {
                no: 'Start månedlig sparing',
                en: '',
            },
            SUBTITLE: {
                no: 'Opprett AvtaleGiro for å starte sparingen.',
                en: '',
            },
        },
        OTP: {
            TITLE: {
                no: 'Spar et enkeltbeløp',
                en: '',
            },
            SUBTITLE: {
                no: 'Du bestemmer hvor mye og hvor ofte du vil spare, og du bruker KID- og kontonummer nedenfor.',
                en: '',
            },
        },
        CREATE_AVTALEGIRO_INFO: {
            no: (React.createElement(React.Fragment, null,
                "Opprett ",
                React.createElement("b", null, "AvtaleGiro"),
                " med trekkdato den 1. i hver m\u00E5ned.")),
            en: '',
        },
        ANNUITY_HEADER: {
            no: 'Månedlig sparebeløp',
            en: '',
        },
        CREATE_AVTALEGIRO: {
            no: 'Opprett AvtaleGiro',
            en: '',
        },
        STEP_TWO: {
            no: 'Steg 2',
            en: '',
        },
        LUMP_SUM_WITH_ANNUITY_INFO: {
            FIRST_PARAGRAPH: {
                no: React.createElement(React.Fragment, null, "Bruk KID- og kontonummeret nedenfor for betaling via nettbanken din."),
                en: '',
            },
            SECOND_PARAGRAPH: {
                no: '',
                en: '',
            },
        },
        PAYMENT_INFO: {
            HEADER: {
                no: 'Betalingsinformasjon',
                en: '',
            },
            INFO_WITH_LUMP_SUM: {
                no: (React.createElement(React.Fragment, null,
                    "Bruk KID- og kontonummeret nedenfor for \u00E5 sette inn ",
                    React.createElement("strong", null, "engangsinnskudd"),
                    " via nettbanken din.")),
                en: '',
            },
            INFO_WITHOUT_LUMP_SUM: {
                no: (React.createElement(React.Fragment, null,
                    "Bruk KID- og kontonummeret nedenfor for \u00E5 sette inn ",
                    React.createElement("strong", null, "engangsinnskudd"),
                    " eller sette opp",
                    ' ',
                    React.createElement("strong", null, "faste oppdrag"),
                    " via nettbanken din.")),
                en: '',
            },
        },
        KID_NUMBER: {
            no: 'KID nummer:',
            en: '',
        },
        ACCOUNT_NUMBER: {
            no: 'Kontonummer:',
            en: '',
        },
        ENTERED_LUMP_SUM: {
            no: 'Avtalt engangsinnskudd:',
            en: '',
        },
        KID_AND_ACCOUNT_NUMBER_INFO: {
            no: 'For senere innbetalinger, finner du KID- og kontonummer under avtaleoversikten.',
            en: '',
        },
    },
    AVTALEGIRO_PAGE: {
        TITLE: {
            no: 'Sparingen er i gang',
            en: '',
        },
        CARD_TITLE: {
            no: 'AvtaleGiro er opprettet',
            en: '',
        },
        CARD_SUBTITLE: (amount, trekkdato) => ({
            no: (React.createElement(React.Fragment, null,
                "Avtalt sparebel\u00F8p p\u00E5 ",
                React.createElement("strong", null,
                    amount,
                    " kroner"),
                " blir overf\u00F8rt den ",
                trekkdato.day,
                ". i hver m\u00E5ned, f\u00F8rste gang den ",
                trekkdato.toLocaleString(),
                ". Det tar litt ekstra tid \u00E5 opprette AvtaleGiro f\u00F8rste gangen.")),
            en: React.createElement(React.Fragment, null),
        }),
        SAVE_MORE: {
            no: 'Vil du innbetale litt ekstra?',
            en: '',
        },
        SAVE_MORE_SUBTITLE: {
            no: 'Bruk KID- og kontonummeret nedenfor for å sette inn engangsinnskudd via nettbanken din.',
            en: '',
        },
        ERROR_CANCELED: {
            no: 'Opprettelsen ble avbrutt',
            en: '',
        },
        ERROR_GENERIC_AVTALEGIRO: {
            no: 'Det oppstod en feil hos Nets under opprettelse av AvtaleGiro',
            en: '',
        },
        ERROR_SUBTEXT: {
            no: 'For å prøve igjen, vennligst følg lenken i e-posten på nytt. Eventuelt kan du opprette AvtaleGiro manuelt' +
                ' i din nettbank (bruk KID- og kontonummer fra e-posten).',
            en: '',
        },
        KID_AND_ACCOUNT_NUMBER_INFO: {
            no: 'For senere innbetalinger, finner du KID- og kontonummer under avtaleoversikten.',
            en: '',
        },
        AVTALEGIRO_FAILED: {
            no: 'Avtalegiroen ble ikke opprettet',
            en: '',
        },
    },
};
